import React, { useCallback, useEffect, useState } from 'react'
import DefaultCrudForm from '../DefaultCrudForm'

import { useNavigate, useSearchParams } from 'react-router-dom';

import useNotification from 'notification';
import { flog } from 'util/FileLogger';
import { useUserUid } from 'useAuth';
export default function DefaultEntityCrud({ EntityClass, children, routeForm, ...othersProps }) {
    const navigate = useNavigate();
    const [initialValues, setInitialValues] = useState({})
    const { showSuccess, showWarning } = useNotification()
    const [searchParams] = useSearchParams();
    const searchUid = searchParams.get("uid")
    const userUid = useUserUid()

    const setNewValues = useCallback(async () => {
        let entity = await EntityClass.create();
        flog(EntityClass.collectionUID + " - GO NEW ")
        // console.log('setNewValues', entity.data)
        setInitialValues(entity.data)
    }, [EntityClass])

    useEffect(() => {
        let observer = null
        console.log('start Tela', searchUid)
        if (searchUid) {
            // console.log('start observer', searchUid)
            observer = EntityClass.onSnapshot(searchUid, (obj) => {
                // console.log('obj', obj)
                setInitialValues(obj)
            })
        } else {
            setNewValues()
        }

        return () => {
            if (observer) {
                console.log('remove observer', searchUid)
                observer()
            }
        }
    }, [EntityClass, searchUid, setNewValues])


    const saveValues = (values) => {
        flog(`UserUid ${userUid} - ${EntityClass.collectionUID} - start save ${EntityClass.collectionUID} - ${values.uid}`)
        let entity = new EntityClass()
        console.log("saveValues", values)
        entity.update(values);

        entity.save().then(() => {
            // console.log('salvou')
            showSuccess("Salvo com Sucesso")
            navigate("/" + routeForm + "?uid=" + entity.data.uid)
        })
    }
    const validValues = async (values) => {
        let errors = await EntityClass.validFieldErrors(values)

        if (errors) {
            if (errors.length) {
                showWarning(`${errors?.join("; ")}`)
                return false
            }
        }

        return true;
    }


    return (<DefaultCrudForm saveValues={saveValues} validValues={validValues} initialValues={initialValues} setNewValues={setNewValues} routeForm={routeForm} {...othersProps}>
        {(formProps) => children(formProps)}
    </DefaultCrudForm>

    )
}